import {combineReducers} from "redux";
import toasts from "src/redux/reducers/toasts";
import auth from "src/redux/reducers/auth"

export default combineReducers({
  toasts,
  auth
});
